<template>
    <v-app pb-3>
        <v-content class="osago-pre-calc-steps mortgage-container">
            <v-container style="max-width: 1240px" class="py-4 header-part">
                <v-layout class="header-part-title" row wrap pt-5>
                    <v-flex class="top-title" xs12 py-4>
                        <a href="/list">Личный кабинет</a>
                    </v-flex>
                    <v-flex xs12>
                        <h1>Расчет <br/>страхования ипотеки</h1>
                    </v-flex>
                </v-layout>

                <v-layout v-if="step === 1 || step === 2" wrap row>
                    <v-flex class="main-part" xs12>
                        <v-form ref="form1" v-model="form1Valid">
                            <mortgage-precalc-info
                                v-model="precalcInfo"
                                :banks="precalcInfo.banks"
                                :step="step"
                                @changedBank="changedBank"
                                @changeBirthday="changeBirthday"
                                @save="save"
                                @checkApartment="checkApartment"
                                @checkTitle="checkTitle"
                                @policyTypeChanged="policyTypeChanged"
                            ></mortgage-precalc-info>
                            <v-layout pt-2 row wrap>
                                <v-flex class="bottom-block">
                                    <v-flex class="buttons-block">
                                        <v-btn
                                            @click="precalc"
                                            class="button next-button block"
                                            :loading="waitCalc"
                                            :disabled="waitCalc"
                                            v-if="step === 1"
                                        >
                                            Узнать стоимость
                                        </v-btn>
                                        <v-btn
                                            @click="precalc"
                                            class="button next-button block"
                                            :loading="waitCalcButton"
                                            :disabled="waitCalcButton"
                                            v-if="step === 2"
                                        >
                                            Пересчитать
                                        </v-btn>
                                    </v-flex>
                                </v-flex>
                            </v-layout>
                        </v-form>
                    </v-flex>
                    <v-flex xs12 v-if="step === 2 && companiesList.length">
                        <mortgage-calc-result
                            :data="companiesList"
                            :policyType="precalcInfo.policyType"
                            :wait="waitIssue"
                            :showCommission="showCommission"
                            :precalcBank="precalcInfo.bank"
                            :step="step"
                            :isPolicyTypeChanged="isPolicyTypeChanged"
                            :showType="showType"
                            @setShowType="setShowType"
                            @nextStep="nextStep"
                            class="container-no-paddings"
                        ></mortgage-calc-result>
                    </v-flex>
                </v-layout>

                <v-layout wrap row v-if="step === 3">
                    <v-flex xs12>
                        <v-form ref="form2" v-model="form2Valid">
                            <mortgage-precalc-info
                                v-model="precalcInfo"
                                :banks="precalcInfo.banks"
                                :step="step"
                                @changedBank="changedBank"
                                @changeBirthday="changeBirthday"
                                @save="save"
                                @policyTypeChanged="policyTypeChanged"
                                @checkApartment="checkApartment"
                                @checkTitle="checkTitle"
                                :showContractDate="false"
                            ></mortgage-precalc-info>
                            <mortgage-calc-info
                                :uuid="uuid"
                                v-model="calcInfo"
                                :duration="precalcInfo.duration"
                                :precalcInfo="precalcInfo"
                                @changeApartmentArea="changeApartmentArea"
                                @changeBirthday="changeBirthday"
                                @deleteContractNumber="deleteContractNumber"
                                @updateRegistrationAddress="updateRegistrationAddress"
                                @changeTempPolicyEndDate="changeTempPolicyEndDate"
                            ></mortgage-calc-info>
                        </v-form>
                    </v-flex>
                    <v-flex xs12 mb-3 pt-3>
                        <v-layout pt-2 row wrap>
                            <v-flex class="bottom-block">
                                <v-flex class="buttons-block">
                                    <v-btn
                                        @click="showPreview"
                                        class="button next-button block final-button big-button"
                                        :loading="waitCalcButton"
                                        :disabled="orderStatus === 'success' || waitCalcButton"
                                    >
                                        {{ orderStatus === 'success' ? 'Полис оформлен' : 'Рассчитать и оформить' }}
                                    </v-btn>
                                </v-flex>
                                <v-flex class="terms-and-conditions">
                                    <v-form
                                        ref="formPrivacyPolicyApproved"
                                        v-model="formPrivacyPolicyApprovedValid"
                                    >
                                        <v-checkbox
                                            v-model="privacyPolicyApproved"
                                            :rules="[rules.approvePrivacyPolicy]"
                                            class="mt-0"
                                        >
                                            <template v-slot:label>
                                                <div class="policy-wrapper">
                                                    Отправляя анкету, соглашаюсь
                                                    <br/>с
                                                    <a
                                                        class="policy"
                                                        target="_blank"
                                                        href="https://getpolis.ru/osago_policy"
                                                    >политикой обработки персональных данных</a>
                                                    <br/>и даю
                                                    <a
                                                        class="policy"
                                                        target="_blank"
                                                        href="https://getpolis.ru/soglasie_pdn"
                                                    >Согласие на обработку персональных данных</a>
                                                </div>
                                            </template>
                                        </v-checkbox>
                                    </v-form>
                                </v-flex>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                    <v-flex xs12 pt-5 v-if="step === 3 && companiesList.length">
                        <mortgage-calc-result
                            :data="companiesList"
                            :policyType="precalcInfo.policyType"
                            :duration="resultDuration"
                            :phone="calcInfo.user.phone"
                            :isResult="true"
                            :wait="waitIssue"
                            :key="calcResultKey"
                            :showCommission="showCommission"
                            @issue="issue"
                            :formIsChanged="formIsChanged"
                            :order-status="orderStatus"
                            :successProcessing="successProcessing"
                            @showConfirmModal="showConfirmModal"
                            :showType="showType"
                            @setShowType="setShowType"
                            :isPolicyTypeChanged="isPolicyTypeChanged"
                            :titleRequired="titleRequired"
                        ></mortgage-calc-result>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-content>

        <transition name="fade">
            <mortgage-preview-data
                v-if="toShowPreview"
                :precalcInfo="precalcInfo"
                :calcInfo="calcInfo"
                @returnToEdit="returnToEdit"
                @submit="submit"
            />
        </transition>

        <v-dialog
            v-model="dialogConfirmModal"
            :max-width='800'
        >
            <mortgage-confirm-modal
                :data="itemsConfirmModal.data"
                :phone="itemsConfirmModal.phone"
                :wait="waitIssue"
                :isLink="itemsConfirmModal.isLink"
                :dialogConfirmModal="dialogConfirmModal"
                @issue="issue"
                :key="rerenderModalId"
                @isSubmitLoading="isSubmitLoading"
            >
            </mortgage-confirm-modal>
        </v-dialog>
    </v-app>
</template>

<script>
import MortgageCalcResult from "./MortgageCalcResult";
import _ from "lodash";
import moment from "moment";
import MortgagePreview from "./MortgagePreview";
import MortgageConfirmModal from './MortgageConfirmModal';

export default {
    name: "MortgagePrecalcForm",
    components: {
        "mortgage-calc-result": MortgageCalcResult,
        "mortgage-preview-data": MortgagePreview,
        "mortgage-confirm-modal": MortgageConfirmModal
    },
    props: ["params", "authUser"],
    data: () => ({
        form1Valid: false,
        form2Valid: false,
        step: 1,
        orderStatus: 'new',
        showCommission: true,
        waitCalc: false,
        waitCalcButton: false,
        waitIssue: false,
        formPrivacyPolicyApprovedValid: false,
        privacyPolicyApproved: false,
        uuid: null,
        preparedFormData: {},
        companiesList: [],
        calcResultKey: 1,
        toShowPreview: false,
        mortgageCompanies: [],

        precalcInfo: {
            bank: null,
            duration: null,
            banks: [],
            creditRemainder: null,
            gender: null,
            birthday: null,
            additionalProperties: {
                hasWoodenFloors: false,
                houseGasificated: false,
            },
            policyType: {
                life: true,
                apartment: true,
                title: false,
            },
            acceptTitleRules: false,
            contract: {
                dateStart: null,
            },
        },
        calcInfo: {
            insuranceCompany: [],
            noContractNumber: false,
            contract: {
                number: null,
                dateStart: null,
                dateEnd: null,
                mortgageRate: null,
                annuityPayment: null,
                creditPercentBetRefus: null,
            },
            policyStartDate: null,
            policyEndDate: null,
            user: {
                phone: "7",
                email: null,
            },
            fio: {
                name: null,
                surname: null,
                patronymic: null,
                noPatronymic: false
            },
            birthday: null,
            birthPlace: null,
            passport: {
                date: null,
                seriesNumber: null,
                subdivisionCode: null,
                issuedBy: null,
            },
            height: null,
            weight: null,
            equalRegistrationAddress: false,
            registrationAddress: {
                search: null,
                city: null,
                street: null,
                house: null,
                house_kladr: null,
                house_fias: null,
                flat: null,
                flat_cadnum: null,
                city_fias_id: null,
                postalCode: null,
                region: null,
            },
            mortgageAddress: {
                search: null,
                city: null,
                street: null,
                house: null,
                house_kladr: null,
                house_fias: null,
                flat: null,
                flat_cadnum: null,
                postalCode: null,
                city_fias_id: null,
                region: null,
            },
            buildYear: null,
            floorsNumber: null,
            apartmentArea: null,
            marketPrice: null,
            cadastralNumber: null,
            noCadastralNumber: null,
            tempPolicyEndDate: null,
        },
        preloading: false,
        resultPreloading: false,
        stepFlags: [],
        durationInfoDefault: 'year',
        resultDuration: '1 год',
        lastSavedFormData: null,

        rules: {
            approvePrivacyPolicy: (v) =>
                v || "Необходимо согласиться с политикой обработки персональных данных",
        },
        formIsChanged: false,
        successProcessing: {
            companyType: null,
            companyId: null,
            premium: null,
        },
        titleRequired: null,
        dialogConfirmModal: false,
        itemsConfirmModal: {},
        showType: 'union',
        isPolicyTypeChanged: false,
        rerenderModalId: 0,
        role: '',
    }),
    watch: {
        'calcInfo.policyEndDate': {
            handler: function () {
                this.setResultDuration()
            },
            deep: true
        },
        toShowPreview: {
            handler(val, oldVal) {
            },
            deep: true
        },
        'precalcInfo.policyType': {
            handler() {
                if (this.precalcInfo.policyType.life && this.precalcInfo.policyType.apartment) {
                    this.showType = 'union';
                } else {
                    this.showType = 'separate';
                }
            },
            deep: true,
        },
        'calcInfo.registrationAddress': {
            handler() {
                if (this.calcInfo.equalRegistrationAddress) {
                    this.calcInfo.mortgageAddress = JSON.parse(JSON.stringify(this.calcInfo.registrationAddress));
                    this.$nextTick(() => {
                        this.save();
                    });
                }
            },
            deep: true,
        },
    },
    updated: () => {
        window.tippy.default('.tip-icon');
    },
    created() {
        const params = JSON.parse(window.atob(this.params));
        this.uuid = params.uuid;
        if (params.banks) {
            this.precalcInfo.banks = params.banks;
        }
        if (params.orderData) {
            this.loadOrderData(params.orderData);
        }
        if (!params.orderData) {
            if (this.authUser && (this.authUser.email || this.authUser.phone)) {
                this.calcInfo.user = {
                    email: this.authUser.email ? this.authUser.email : '',
                    phone: this.authUser.phone ? this.authUser.phone.replace(/\D/g, '') : '',
                };
            }
        }
        if (params.companies) {
            this.companiesList = params.companies.sort(this.sortByCost);
        }
        if (params.orderStatus) {
            this.orderStatus = params.orderStatus;
        }
        if (typeof params.showCommission !== 'undefined') {
            this.showCommission = params.showCommission;
        }

        if (params.mortgageCompanies) {
            this.mortgageCompanies = params.mortgageCompanies;
        }

        if (params.successProcessing) {
            const parsedIds = JSON.parse(params.successProcessing.company_ids);
            this.successProcessing.companyType = Object.keys(parsedIds).join(',');
            const firstKey = Object.keys(parsedIds)[0];
            this.successProcessing.companyId = parsedIds[firstKey];
            this.successProcessing.premium = parseInt(params.successProcessing.premium);
        }

        if (params.role) {
            this.role = params.role;
        }

        if (this.precalcInfo.policyType.title) {
            this.requiredTitleOrNot();
        }

        this.deleteContractNumber();

        this.updateRegistrationAddress();

        if (this.precalcInfo.policyType.life && this.precalcInfo.policyType.apartment) {
            this.showType = 'union';
        } else {
            this.showType = 'separate';
        }

        this.autoSaveOn(5000);

        this.setResultDuration()
    },
    methods: {
        setResultDuration() {
            if (this.precalcInfo.duration !== 'year') {
                this.resultDuration = this.convertDataToString(this.calcInfo.policyStartDate, this.calcInfo.policyEndDate)
                return
            }
            this.resultDuration = '1 год'
        },
        deleteContractNumber() {
            if (this.calcInfo.noContractNumber) {
                this.calcInfo.contract.number = null;
            }
        },
        updateRegistrationAddress() {
            if (this.calcInfo.equalRegistrationAddress) {
                this.calcInfo.mortgageAddress = JSON.parse(JSON.stringify(this.calcInfo.registrationAddress));
                this.$nextTick(() => {
                    this.save();
                });
            }
        },
        convertDataToString(start, end) {
            let startDataText, endDataText
            startDataText = endDataText = 'Установите дату'
            if (start) {
                startDataText = moment(start).format('DD.MM.YYYY')
            }
            if (end) {
                endDataText = moment(end).format('DD.MM.YYYY')
            }
            return `${startDataText} - ${endDataText}`
        },
        autoSaveOn(timeout) {
            this.autoSaveInterval = setInterval(() => {
                this.prepareFormData();

                if (this.lastSavedFormData == null) {
                    this.lastSavedFormData = _.cloneDeep(this.preparedFormData);
                    return;
                }
                if (!_.isEqual(this.lastSavedFormData, this.preparedFormData)) {
                    this.save();
                    this.lastSavedFormData = _.cloneDeep(this.preparedFormData);
                    if (this.step === 3 && !this.formIsChanged && !this.waitCalcButton && !this.dialogConfirmModal) {
                        this.formIsChanged = true
                        this.waitCalcButton = false;
                    }
                }
            }, timeout);
        },
        autoSaveOff() {
            clearInterval(this.autoSaveInterval);
        },
        loadOrderData(data) {
            console.log(data);
            this.precalcInfo.bank = data.bank;
            this.precalcInfo.duration = this.getDuration(data.bank);
            this.precalcInfo.creditRemainder = data.remainingCredit
                ? data.remainingCredit.replace(/(\d)(?=(\d{3})+(\D|$))/g, "$1 ")
                : data.remainingCredit;
            this.step = data.step;
            this.precalcInfo.additionalProperties = {
                houseGasificated: data.additional.houseGasificated,
                hasWoodenFloors: data.additional.hasWoodenFloors,
            };
            this.precalcInfo.policyType = {
                life: data.policyType.life,
                apartment: data.policyType.apartment,
                title: data.mortgage.titleCalc,
            };
            this.precalcInfo.acceptTitleRules = data.acceptTitleRules;
            this.precalcInfo.gender = data.insurer.gender;
            this.precalcInfo.birthday = data.insurer.birthdate;
            this.precalcInfo.contract = {
                dateStart: data.contract.startDate,
            };

            this.calcInfo.insuranceCompany = data.insuranceCompany;
            this.calcInfo.noContractNumber = data.contract.noNumber;
            this.calcInfo.contract = {
                number: data.contract.number,
                dateStart: data.contract.startDate,
                dateEnd: data.contract.endDate,
                mortgageRate: data.contract.mortgageRate,
                annuityPayment: data.contract.annuityPayment,
                creditPercentBetRefus: data.contract.creditPercentBetRefus,
            };
            this.calcInfo.policyStartDate = data.mortgage.startDate;
            this.calcInfo.policyEndDate = data.mortgage.endDate;
            this.calcInfo.buildYear = data.mortgage.buildYear;
            this.calcInfo.floorsNumber = data.mortgage.floorsNumber;
            this.calcInfo.apartmentArea = data.mortgage.apartmentArea;
            /*this.calcInfo.marketPrice = data.mortgage.marketPrice;*/
            this.calcInfo.cadastralNumber = data.mortgage.cadastralNumber;
            this.calcInfo.noCadastralNumber = data.mortgage.noCadastralNumber;
            this.calcInfo.user = {
                email: data.user.email ? data.user.email : this.authUser.email,
                phone: data.user.phone && data.user.phone !== '7' ? data.user.phone.replace(/\D/g, '') : this.authUser.phone,
            };
            this.calcInfo.fio = {
                name: data.insurer.fio.name,
                surname: data.insurer.fio.surname,
                patronymic: data.insurer.fio.patronymic,
                noPatronymic: data.insurer.fio.noPatronymic
            };
            this.calcInfo.birthday = data.insurer.birthdate;
            this.calcInfo.birthPlace = data.insurer.birthPlace;
            this.calcInfo.height = data.insurer.height;
            this.calcInfo.weight = data.insurer.weight;
            this.calcInfo.passport = {
                date: data.insurer.passport.issueDate,
                seriesNumber: data.insurer.passport.seriesNumber,
                subdivisionCode: data.insurer.passport.subdivisionCode,
                issuedBy: data.insurer.passport.issuedBy,
            };
            this.calcInfo.equalRegistrationAddress = data.equalRegistrationAddress
            this.calcInfo.registrationAddress = {
                search: data.insurer.registrationAddress.string,
                house: data.insurer.registrationAddress.house,
                house_fias: data.insurer.registrationAddress.fias,
                house_kladr: data.insurer.registrationAddress.kladr,
                flat: data.insurer.registrationAddress.flat,
                flat_cadnum: data.insurer.registrationAddress.flat_cadnum,
                city_fias_id: data.insurer.registrationAddress.city_fias_id,
                postalCode: data.insurer.registrationAddress.postalCode,
                region: data.insurer.registrationAddress.region,
                city: data.insurer.registrationAddress.city,
                street: data.insurer.registrationAddress.street,
            };
            this.calcInfo.mortgageAddress = {
                search: data.mortgage.mortgageAddress.string,
                house: data.mortgage.mortgageAddress.house,
                house_fias: data.mortgage.mortgageAddress.fias,
                house_kladr: data.mortgage.mortgageAddress.kladr,
                flat: data.mortgage.mortgageAddress.flat,
                flat_cadnum: data.mortgage.mortgageAddress.flat_cadnum,
                city_fias_id: data.mortgage.mortgageAddress.city_fias_id,
                postalCode: data.mortgage.mortgageAddress.postalCode,
                region: data.mortgage.mortgageAddress.region,
                city: data.mortgage.mortgageAddress.city,
                street: data.mortgage.mortgageAddress.street,
            };
            this.privacyPolicyApproved = data.privacyPolicyApproved
        },
        getDuration(bank) {
            let bankObject = this.precalcInfo.banks.find((item) => {
                return item.alias === bank;
            })
            if (bankObject && bankObject.duration) {
                return bankObject.duration
            }
            return this.durationInfoDefault
        },
        back() {
            this.step--;
        },
        nextStep() {
            this.validate();
            if (this.step === 2) {
                this.companiesList = {};
            }
            this.step++;
        },
        validate() {
            if (this.step === 1 || this.step === 2) {
                if (!this.$refs.form1.validate()) {
                    return false;
                }
            }
            if (this.step === 3) {
                if (!this.$refs.form2.validate() || !this.$refs.formPrivacyPolicyApproved.validate()) {
                    return false;
                }
            }
            return true;
        },
        save() {
            this.prepareFormData();
            this.waitCalcButton = true;

            if (this.orderStatus !== 'success') {
                const url = this.uuid ? `/mortgage/calc/${this.uuid}/update` : "/mortgage/calc/new";

                axios
                    .post(url, this.preparedFormData)
                    .then((response) => {
                        if (response.data.uuid) {
                            this.uuid = response.data.uuid;
                            window.history.pushState(
                                null,
                                null,
                                "/mortgage/calc/" + this.uuid
                            );
                        }

                        setTimeout(() => {
                            this.waitCalcButton = false;
                        }, 1000);

                        //this.waitCalcButton = false;
                    })
                    .catch((error) => {
                        this.catchSubmitError(error);
                    });
            }
        },
        createCompaniesList() {
            let list = [];
            let policyType = null;

            if (this.precalcInfo.policyType.apartment === true && this.precalcInfo.policyType.life === true) policyType = "lifeAndApartment"
            if (this.precalcInfo.policyType.apartment === true && this.precalcInfo.policyType.life === false) policyType = "apartment"
            if (this.precalcInfo.policyType.apartment === false && this.precalcInfo.policyType.life === true) policyType = "life"

            this.mortgageCompanies.forEach(mortgageCompany => {
                list.push({
                    alias: 'calc_' + mortgageCompany.alias,
                    apartment: mortgageCompany.alias,
                    apartmentImage: mortgageCompany.image,
                    apartmentName: mortgageCompany.name,
                    life: mortgageCompany.alias,
                    lifeImage: mortgageCompany.image,
                    lifeName: mortgageCompany.name,
                    error: "",
                    type: policyType,
                    premium: 0,
                    calc: true,
                })
            });
            return list
        },
        precalc() {
            if (this.validate()) {
                this.isPolicyTypeChanged = false;
                this.waitCalc = true;
                this.waitCalcButton = true;
                setTimeout(() => {
                    this.waitCalcButton = false;
                }, 10000)
                this.companiesList = [];
                this.companiesList = this.createCompaniesList();
                this.save();
                this.$nextTick(() => {
                    if (this.step === 1) {
                        this.nextStep();
                        this.precalcInfo.duration = this.getDuration(this.precalcInfo.bank)
                    }
                    this.sendRequests('precalc')
                });
            } else {
                this.goToFirstError();
            }
        },
        calc() {
            this.save();
            if (this.validate()) {
                this.waitCalc = true;
                this.waitCalcButton = true;
                setTimeout(() => {
                    this.waitCalcButton = false;
                }, 10000)
                this.companiesList = [];
                this.companiesList = this.createCompaniesList();
                this.save();
                this.$nextTick(() => {
                    if (this.step === 1) {
                        this.nextStep();
                        this.precalcInfo.duration = this.getDuration(this.precalcInfo.bank)
                    }
                    let promises = this.sendRequests('calc')
                    Promise.all(promises).then(() => {
                        this.waitCalc = false
                        this.calcResultKey++
                    });
                });
            } else {
                this.goToFirstError();
            }
        },
        sendRequests(type) {
            axios.get(`/mortgage/calc/${this.uuid}/create`)
                .then(response => {
                    console.log(response)
                })
                .catch(error => {
                    this.catchError(error);
                });

            this.mortgageCompanies.forEach((mortgageCompany, index) => {
                setTimeout(() => {
                    axios.get(`/mortgage/calc/${this.uuid}/${type}/${mortgageCompany.alias}`)
                        .then(response => {
                            if (response.data.error) {
                                this.companiesList.forEach((company, index) => {
                                    if (company.alias != null && company.alias === 'calc_' + mortgageCompany.alias) {
                                        this.companiesList[index].error = response.data.error;
                                        this.waitCalc = false;
                                        this.calcResultKey += 1;
                                    }
                                });
                            } else {

                                // Специфическая обработка для ВТБ и ПАРИ
                                if (
                                    this.precalcInfo.bank === 'vtb' &&
                                    mortgageCompany.alias === 'pari_mortgage' &&
                                    (this.step === 1 || this.step === 2)
                                ) {
                                    response.data.forEach(item => {
                                        item.premium = 0;
                                    });
                                }

                                this.companiesList.forEach((company, index) => {
                                    if (company.alias != null && company.alias === 'calc_' + mortgageCompany.alias) {
                                        this.companiesList.splice(index, 1);
                                        this.waitCalc = false;
                                        this.calcResultKey += 1;
                                    }
                                });

                                this.companiesList = this.companiesList
                                    .concat(response.data)
                                    .sort(this.sortByCost);
                                this.companiesList = this.companiesList.filter((company, index, self) => {
                                    return self.findIndex((c) =>
                                        (c.type === company.type && c.apartment === company.apartment && c.life === company.life)) === index;
                                });
                            }
                        })
                        .catch(error => {
                            this.catchError(error);
                        });
                }, index * 10); // Задержка в 10 миллисекунд для каждого запроса
            });

            if (type === 'calc') {
                this.waitCalc = false;
                this.calcResultKey += 1;
            }
        },

        /*
        async sendRequests(type) {
            // Итерируемся по каждой компании в mortgageCompanies
            for (const mortgageCompany of this.mortgageCompanies) {
                try {
                    const response = await axios.get(`/mortgage/calc/${this.uuid}/${type}/${mortgageCompany.alias}`);

                    if (response.data.error) {
                        this.companiesList.forEach((company, index) => {
                            if (company.alias != null && company.alias === 'calc_' + mortgageCompany.alias) {
                                this.companiesList[index].error = response.data.error;
                                this.waitCalc = false;
                                this.calcResultKey += 1;
                            }
                        });
                    } else {

                        // Специфическая обработка для ВТБ и ПАРИ
                        if (
                            this.precalcInfo.bank === 'vtb' &&
                            mortgageCompany.alias === 'pari_mortgage' &&
                            (this.step === 1 || this.step === 2)
                        ) {
                            response.data.forEach(item => {
                                item.premium = 0;
                            });
                        }

                        // Удаляем записи из companiesList, соответствующие текущей компании
                        this.companiesList.forEach((company, index) => {
                            if (company.alias != null && company.alias === 'calc_' + mortgageCompany.alias) {
                                this.companiesList.splice(index, 1);
                                this.waitCalc = false;
                                this.calcResultKey += 1;
                            }
                        });

                        // Объединяем новый ответ/сортируем по стоимости
                        this.companiesList = this.companiesList
                            .concat(response.data)
                            .sort(this.sortByCost);

                        // Фильтруем companiesList, чтобы удалить дубликаты
                        this.companiesList = this.companiesList.filter((company, index, self) => {
                            return self.findIndex((c) =>
                                (c.type === company.type && c.apartment === company.apartment && c.life === company.life)) === index;
                        });
                    }
                } catch (error) {
                    this.catchError(error);
                }
            }

            if (type === 'calc') {
                this.waitCalc = false;
                this.calcResultKey += 1;
            }
        },
        */
        sortByCost(a, b) {
            if (a.premium === 0) return 1;
            if (b.premium === 0) return -1;
            return a.premium - b.premium
        },
        isSubmitLoading(bool) {
            this.waitIssue = bool;
        },
        issue(data) {
            this.calcInfo.insuranceCompany = data;
            this.$nextTick(() => {
                this.save();
                this.process(data);
            })
        },
        submit() {
            this.toShowPreview = false
            this.formIsChanged = false
            this.isPolicyTypeChanged = false
            this.calc()
            if (this.precalcInfo.policyType.title) {
                this.requiredTitleOrNot();
            }
        },
        showPreview() {
            if (this.validate()) {
                this.toShowPreview = true
                this.formIsChanged = false
                this.$nextTick(function () {
                    $('.preview-window').css('height', $(window).height());
                });
            } else {
                this.$nextTick(function () {
                    PNotify.error('Проверьте правильность выделенных полей.');
                    this.goToFirstError();
                });
            }
        },
        process(insuranceCompany) {
            if (this.validate()) {
                if (this.uuid) {
                    this.save();
                    if (typeof ym === 'function') {
                        ym(100170943, 'reachGoal', 'sale_click_btn', {
                            order_price: insuranceCompany.premium,
                            currency: 'RUB',
                        });
                    }
                    setTimeout(() => {
                        axios
                            .post("/mortgage/calc/" + this.uuid + "/process", insuranceCompany)
                            .then((response) => {
                                if (response) {
                                    if (this.calcInfo.insuranceCompany.isLink) {
                                        window.open(
                                            response.data.manageLink,
                                            '_blank'
                                        );
                                    } else {
                                        window.open(
                                            response.data.link,
                                            '_blank'
                                        );
                                    }
                                }
                            })
                            .catch((error) => {
                                this.catchError(error, true);
                            })
                            .finally(() => {
                                this.waitIssue = false
                            })
                    }, 2000)
                }
            } else {
                this.waitIssue = false;
                this.goToFirstError();
            }
        },
        prepareFormData() {
            this.preparedFormData = {
                bank: this.precalcInfo.bank,
                duration: this.getDuration(this.precalcInfo.bank),
                remainingCredit: this.precalcInfo.creditRemainder
                    ? this.precalcInfo.creditRemainder.replace(/\s/g, "")
                    : this.precalcInfo.creditRemainder,
                step: this.step,
                insuranceCompany: this.calcInfo.insuranceCompany,
                user: {
                    email: this.calcInfo.user.email,
                    phone: this.calcInfo.user.phone,
                },
                equalRegistrationAddress: this.calcInfo.equalRegistrationAddress,
                acceptTitleRules: this.precalcInfo.acceptTitleRules,
                insurer: {
                    gender: this.precalcInfo.gender,
                    birthdate: this.calcInfo.birthday
                        ? this.calcInfo.birthday
                        : this.precalcInfo.birthday,
                    birthPlace: this.calcInfo.birthPlace,
                    fio: {
                        surname: this.calcInfo.fio.surname,
                        name: this.calcInfo.fio.name,
                        patronymic: this.calcInfo.fio.patronymic,
                        noPatronymic: this.calcInfo.fio.noPatronymic
                    },
                    passport: {
                        seriesNumber: this.calcInfo.passport.seriesNumber,
                        issueDate: this.calcInfo.passport.date,
                        subdivisionCode: this.calcInfo.passport.subdivisionCode,
                        issuedBy: this.calcInfo.passport.issuedBy,
                    },
                    height: this.calcInfo.height,
                    weight: this.calcInfo.weight,
                    mortgageAddress: {
                        kladr: this.calcInfo.mortgageAddress.house_kladr,
                        fias: this.calcInfo.mortgageAddress.house_fias,
                        city: this.calcInfo.mortgageAddress.city,
                        street: this.calcInfo.mortgageAddress.street,
                        house: this.calcInfo.mortgageAddress.house,
                        string: this.calcInfo.mortgageAddress.search,
                        flat: this.calcInfo.mortgageAddress.flat,
                        flat_cadnum: this.calcInfo.mortgageAddress.flat_cadnum,
                        city_fias_id: this.calcInfo.mortgageAddress.city_fias_id,
                        region: this.calcInfo.mortgageAddress.region,
                        postalCode: this.calcInfo.mortgageAddress.postalCode,
                    },
                    registrationAddress: {
                        kladr: this.calcInfo.registrationAddress.house_kladr,
                        fias: this.calcInfo.registrationAddress.house_fias,
                        city: this.calcInfo.registrationAddress.city,
                        street: this.calcInfo.registrationAddress.street,
                        house: this.calcInfo.registrationAddress.house,
                        string: this.calcInfo.registrationAddress.search,
                        flat: this.calcInfo.registrationAddress.flat,
                        flat_cadnum: this.calcInfo.registrationAddress.flat_cadnum,
                        city_fias_id: this.calcInfo.registrationAddress.city_fias_id,
                        region: this.calcInfo.registrationAddress.region,
                        postalCode: this.calcInfo.registrationAddress.postalCode,
                    },
                },
                contract: {
                    noNumber: this.calcInfo.noContractNumber,
                    number: this.calcInfo.contract.number,
                    startDate: this.calcInfo.contract.dateStart || this.precalcInfo.contract.dateStart,
                    endDate: this.calcInfo.contract.dateEnd,
                    mortgageRate: this.calcInfo.contract.mortgageRate,
                    annuityPayment: this.calcInfo.contract.annuityPayment,
                    creditPercentBetRefus: this.calcInfo.contract.creditPercentBetRefus,
                },
                additional: {
                    hasWoodenFloors:
                    this.precalcInfo.additionalProperties.hasWoodenFloors,
                    houseGasificated:
                    this.precalcInfo.additionalProperties.houseGasificated,
                },
                policyType: {
                    life: this.precalcInfo.policyType.life,
                    apartment: this.precalcInfo.policyType.apartment,
                },
                mortgage: {
                    mortgageAddress: {
                        kladr: this.calcInfo.mortgageAddress.house_kladr,
                        fias: this.calcInfo.mortgageAddress.house_fias,
                        city: this.calcInfo.mortgageAddress.city,
                        street: this.calcInfo.mortgageAddress.street,
                        house: this.calcInfo.mortgageAddress.house,
                        string: this.calcInfo.mortgageAddress.search,
                        flat: this.calcInfo.mortgageAddress.flat,
                        flat_cadnum: this.calcInfo.mortgageAddress.flat_cadnum,
                        city_fias_id: this.calcInfo.mortgageAddress.city_fias_id,
                        postalCode: this.calcInfo.mortgageAddress.postalCode,
                        region: this.calcInfo.mortgageAddress.region,
                    },
                    buildYear: this.calcInfo.buildYear,
                    floorsNumber: this.calcInfo.floorsNumber,
                    apartmentArea: this.calcInfo.apartmentArea,
                    marketPrice: this.calcInfo.marketPrice,
                    cadastralNumber: this.calcInfo.cadastralNumber,
                    noCadastralNumber: this.calcInfo.noCadastralNumber,
                    startDate: this.calcInfo.policyStartDate,
                    endDate: this.calculatePolicyEndDate(),
                    titleCalc: this.precalcInfo.policyType.title,
                },
                privacyPolicyApproved: this.privacyPolicyApproved
            };
        },
        changeApartmentArea(value) {
            this.$nextTick(() => {
                this.calcInfo.apartmentArea = value
            })
        },
        goToFirstError() {
            this.$vuetify.goTo(".error--text", {
                duration: 600,
                offset: 150,
                easing: "easeInCubic",
            });
        },
        returnToEdit() {
            this.toShowPreview = false;
        },
        catchError(error, forAll = false) {
            if (this.role === 'admin' || forAll) {
                if (error.response.data.message) {
                    PNotify.alert(error.response.data.message);
                }
                throw error;
            } else {
                //PNotify.alert('Что-то пошло не так. Попробуйте позже.');
                //throw error;
            }
        },
        catchSubmitError(error) {
            //this.toShowPreview = false;
            if (error.response.data.message) {
                let errorTexts = "";

                if (error.response.data.errors) {
                    Object.keys(error.response.data.errors).forEach(function (item) {
                        error.response.data.errors[item].forEach(
                            (v) => (errorTexts += " " + v)
                        );
                    });
                }
                if (this.role === 'admin') {
                    if (error.response.data.message) {
                        PNotify.alert('Что-то пошло не так. Попробуйте позже.');
                        throw error;
                    }
                }
                //PNotify.alert(error.response.data.message + errorTexts);
            }
            throw error;
        },
        changedBank(value) {
            this.precalcInfo.duration = this.getDuration(value.bank)
            this.save()
            this.setResultDuration()
        },
        changeBirthday(value) {
            this.$nextTick(() => {
                this.precalcInfo.birthday = value
                this.calcInfo.birthday = value
            })
        },
        showConfirmModal(confirmModalItems) {
            if (confirmModalItems.data && (confirmModalItems.data.apartment || confirmModalItems.data.life)) {
                this.rerenderModalId = (confirmModalItems.data.apartment || confirmModalItems.data.life) + confirmModalItems.data.type;
            } else {
                this.rerenderModalId = 0;
            }
            this.itemsConfirmModal.data = confirmModalItems.data;
            this.itemsConfirmModal.isLink = confirmModalItems.isLink;
            this.itemsConfirmModal.phone = confirmModalItems.phone;
            this.itemsConfirmModal.wait = confirmModalItems.wait;
            this.itemsConfirmModal.uuid = this.uuid;
            this.$nextTick(() => {
                this.dialogConfirmModal = true;
            })
        },
        setShowType(val) {
            this.showType = val;
        },
        policyTypeChanged() {
            this.isPolicyTypeChanged = true;
            this.waitCalcButton = false;
        },
        checkApartment() {
            this.precalcInfo.policyType.apartment = true
        },
        checkTitle() {
            this.precalcInfo.policyType.title = false
        },
        requiredTitleOrNot() {
            const creditYear = moment(this.calcInfo.contract.dateStart).year();
            if (creditYear < this.calcInfo.buildYear) {
                this.titleRequired = false
            } else {
                const years = moment(this.calcInfo.policyStartDate).diff(this.calcInfo.contract.dateStart, 'years');
                if (years < 3) {
                    this.titleRequired = true;
                } else {
                    this.titleRequired = false;
                }
            }
        },
        calculatePolicyEndDate() {
            if (!this.calcInfo || !this.calcInfo.policyStartDate) {
                return '';
            }

            if (!(this.precalcInfo.bank === 'sber' || this.precalcInfo.bank === 'unicreditbank')) {
                this.calcInfo.policyEndDate = this.calcInfo.contract.dateEnd;
                return moment(this.calcInfo.contract.dateEnd).format('YYYY-MM-DD');
            }

            if (this.precalcInfo.duration === 'year') {
                this.calcInfo.policyEndDate = moment(this.calcInfo.policyStartDate).add(1, 'year').subtract(1, 'day').format('YYYY-MM-DD');
            }

            return this.calcInfo.policyEndDate;
        },
        changeTempPolicyEndDate(value) {
            this.$nextTick(() => {
                this.calcInfo.tempPolicyEndDate = value;
            })
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/js/components/mortgage/MortgagePrecalcForm.vue